import store from 'dashboard/store';
import PatientOverviewStressGoalSetting from 'dashboard/templates/views/Patient/Stress/PatientOverviewStressGoalSetting';

export default {
    path: 'goal-setting',
    name: 'PatientRecordStressGoalSetting',
    component: PatientOverviewStressGoalSetting,
    meta: {
        // title: 'Patient Record - Stress Relief - Goal Setting',
        // title: t => `${t('patient.patientRecord')} - ${t('screens.stressReliefSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
        // title: ' Stress Relief - Goal Setting',
        title: t => `${t('screens.stressReliefSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
        loggedInOnly: true,
        inSDMSessionOnly: true,
    },
    async beforeEnter(to, from, next) {
        const currentPatientId = from.params?.patientId;
        const newPatientId = to.params?.patientId;
    
        // Update user if back is used as everything stays cached in computed
        if ((currentPatientId === undefined && newPatientId) ||
            currentPatientId !== undefined && newPatientId !== undefined && currentPatientId !== newPatientId
        ) {
          await Promise.all([
            store.dispatch('patientSummary/get', newPatientId, {root: true}),
          ]);

          next();
        } else {
          next();
        }
      },
};
